module.exports = __webpack_public_path__ + "static/sand_texture-bg-29e0f59e560308e20070cf037f18f31a.jpg";